import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicLoaderComponent } from '../dynamic-loader/dynamic-loader.component';

@Component({
  selector: 'app-contained-loader',
  templateUrl: './contained-loader.component.html',
  styleUrls: ['./contained-loader.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    DynamicLoaderComponent
  ]
})
export class ContainedLoaderComponent {
  @Input() blurBackground = true;
  @Input() diameter = 40;
  @Input() stroke = 3;
  @Input() loaderType = 'company-loader';
}
